import PedidoItemDetToleranciaService from "@/services/PedidoItemDetToleranciaService";

export const pedidoItemDetTolerancia = {
  namespaced: true,
  state: {
    pedidoItemDetTolerancia: {},
  },
  actions: {
    getPedidoItemDetTolerancia({ commit }, payload) {
      return PedidoItemDetToleranciaService.GetPedidoItemDetTolerancia(
        payload
      ).then(
        (pedidoItemDetTolerancia) => {
          return Promise.resolve(pedidoItemDetTolerancia);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postPedidoItemDetTolerancia({ commit }, payload) {
      return PedidoItemDetToleranciaService.PostPedidoItemDetTolerancia(
        payload
      ).then(
        (pedidoItemDetTolerancia) => {
          return Promise.resolve(pedidoItemDetTolerancia);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putPedidoItemDetTolerancia({ commit }, payload) {
      return PedidoItemDetToleranciaService.PutPedidoItemDetTolerancia(
        payload
      ).then(
        (pedidoItemDetTolerancia) => {
          return Promise.resolve(pedidoItemDetTolerancia);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deletePedidoItemDetTolerancia({ commit }, payload) {
      return PedidoItemDetToleranciaService.DeletePedidoItemDetTolerancia(
        payload
      ).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getPedidoItemDetToleranciaOData({ commit }, payload) {
      return PedidoItemDetToleranciaService.GetPedidoItemDetToleranciaOData(
        payload
      ).then(
        (pedidoItemDetTolerancia) => {
          return Promise.resolve(pedidoItemDetTolerancia);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {},
};

export default pedidoItemDetTolerancia;
